import React from 'react';
import { Button as MuiButton } from '@mui/material';
import { motion } from 'framer-motion';
import { styled } from '@mui/material/styles';

/**
 * Animated Button Component with hover and tap effects
 */
const StyledMotionButton = styled(motion(MuiButton))(({ theme, variant }) => ({
  borderRadius: theme.custom.borderRadius.md,
  textTransform: 'none',
  fontWeight: 600,
  padding: '10px 24px',
  boxShadow: variant === 'contained' ? theme.custom.boxShadow.sm : 'none',
  transition: 'all 0.3s ease-in-out',
  
  '&:hover': {
    boxShadow: variant === 'contained' ? theme.custom.boxShadow.md : 'none',
  },
}));

const AnimatedButton = ({ 
  children, 
  variant = 'contained',
  color = 'primary',
  size = 'medium',
  fullWidth = false,
  disabled = false,
  startIcon,
  endIcon,
  onClick,
  ...props 
}) => {
  const motionProps = {
    whileHover: { scale: disabled ? 1 : 1.02 },
    whileTap: { scale: disabled ? 1 : 0.98 },
    transition: { duration: 0.2 },
  };

  return (
    <StyledMotionButton
      {...motionProps}
      variant={variant}
      color={color}
      size={size}
      fullWidth={fullWidth}
      disabled={disabled}
      startIcon={startIcon}
      endIcon={endIcon}
      onClick={onClick}
      {...props}
    >
      {children}
    </StyledMotionButton>
  );
};

export default AnimatedButton;
